import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-placeholder',
    standalone: true,
    imports: [CommonModule, RouterLink],
    templateUrl: './placeholder.component.html',
    styleUrl: './placeholder.component.scss'
})
export class PlaceholderComponent implements OnInit {
    title = '';
    section = '';

    constructor(private route: ActivatedRoute) {}

    ngOnInit() {
        this.title   = this.route.snapshot.data['title']   || 'Page';
        this.section = this.route.snapshot.data['section'] || '';
    }
}
